
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.333 4.667h-2.666V3.333L9.333 2H6.667L5.333 3.333v1.334H2.667c-.734 0-1.334.6-1.334 1.333v3.333c0 .5.267.92.667 1.154v2.18C2 13.407 2.593 14 3.333 14h9.334c.74 0 1.333-.593 1.333-1.333V10.48c.393-.233.667-.66.667-1.147V6c0-.733-.6-1.333-1.334-1.333zM6.667 3.333h2.666v1.334H6.667V3.333zM2.667 6h10.666v3.333H10v-2H6v2H2.667V6zm6 4H7.333V8.667h1.334V10zm4 2.667H3.333v-2H6v.666h4v-.666h2.667v2z","fill":"currentColor"}})])
          )
        }
      }
    